import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { tooltipClasses } from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import { Typography } from '@mui/material';
import { palette } from '../../../../theme/default';
import { LightTooltip } from '../../../atoms/MTooltip/MTooltip';
import { ReactComponent as InfoCircleBlack } from '../../../../assets/icons/InfoCircleBlack.svg';

const DialogLightTooltip = styled(LightTooltip)(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: palette.common.white,
    color: palette.common.black,
    boxShadow: 'none',
    padding: '16px',
    borderRadius: '4px',
    border: '1px solid #EEEEEE',
  },
  [`& .${tooltipClasses.arrow}`]: {
    '&:before': {
      border: '1px solid #EEEEEE',
    },
    color: palette.common.white,
  },
}));

const iconStyles = {
  position: 'absolute',
  top: '16px',
  left: '-30px',
};

const FebruaryExceptionNotification = () => {
  return (
    <>
      <Typography fontSize="14px" fontWeight={500} color={palette.text.primary} pb="5px">
        February Exception
      </Typography>
      <Typography fontSize="12px" fontWeight={400} color={palette.text.secondary}>
        In February, invoices will be exported to QuickBooks on the 28th.
      </Typography>
    </>
  );
};

const NextMonthNotification = () => {
  return (
    <>
      <Typography fontSize="14px" fontWeight={500} color={palette.text.primary} pb="5px">
        Date Applies from Next Month
      </Typography>
      <Typography fontSize="12px" fontWeight={400} color={palette.text.secondary}>
        This recurring date for invoicing automation was updated in the current month. It will
        become effective starting from next month.
      </Typography>
    </>
  );
};

const NextMonthAndFebruaryNotification = () => {
  return (
    <>
      <Typography fontSize="14px" fontWeight={500} color={palette.text.primary} pb="5px">
        Date Applies from Next Month
      </Typography>
      <Typography fontSize="12px" fontWeight={400} color={palette.text.secondary} pb="16px">
        This recurring date for invoicing automation was updated in the current month. It will
        become effective starting from next month.
      </Typography>
      <Typography fontSize="12px" fontWeight={400} color={palette.text.secondary}>
        In February, invoices will be exported to QuickBooks on the 28th.
      </Typography>
    </>
  );
};

const InformTooltip = ({ type }) => {
  const titlesToShow = {
    'february-exception': <FebruaryExceptionNotification />,
    'next-month-exception': <NextMonthNotification />,
    'february-and-next-month-exception': <NextMonthAndFebruaryNotification />,
  };

  if (!type) return null;

  return (
    <DialogLightTooltip title={titlesToShow[type]} placement="top" arrow>
      <IconButton style={iconStyles}>
        <InfoCircleBlack style={{ height: '16px' }} />
      </IconButton>
    </DialogLightTooltip>
  );
};

InformTooltip.propTypes = {
  type: PropTypes.oneOf([
    'february-exception',
    'next-month-exception',
    'february-and-next-month-exception',
  ]),
};

InformTooltip.defaultProps = {
  type: '',
};

export default InformTooltip;
